import * as React from 'react';
import { PasswordResetSuccessForm } from '../../components/forms/password-reset-success-form/password-reset-success-form.component';
import { PageMeta } from '../../components/page-meta';
import { AuthPageLayout } from '../../ui/layout/auth-page-layout/auth-page-layout.component';

export const PasswordResetSuccess: React.FC = () => {
  return (
    <AuthPageLayout>
      <PageMeta title="ui-password-successfully-changed" description="ui-password-successfully-changed-description" />
      <PasswordResetSuccessForm />
    </AuthPageLayout>
  );
};
